export enum DoAnyApplyOption {
  OVERWEIGHT = "OVERWEIGHT",
  OBESITY = "OBESITY",
  DIABETES = "DIABETES",
  METABOLIC_SYNDROME = "METABOLIC_SYNDROME",
  HIGH_CHOLESTEROL = "HIGH_CHOLESTEROL",
  PCOS = "PCOS",
  FATTY_LIVER_DISEASE = "FATTY_LIVER_DISEASE",
  LIPODYSTROPHY = "LIPODYSTROPHY",
  OVER_40 = "OVER_40",
  TWO_LOSSES = "TWO_LOSSES",
  URGENT_MEDICAL_NEED = "URGENT_MEDICAL_NEED",
  NEVER_MENSTRUATED = "NEVER_MENSTRUATED",
  FAMILY_BLOOD_CLOTTING = "FAMILY_BLOOD_CLOTTING",
  RECURRENT_PREGNANCY_LOSS = "RECURRENT_PREGNANCY_LOSS",
  PREECLAMPSIA_HIGH_BLOOD_PRESSURE = "PREECLAMPSIA_HIGH_BLOOD_PRESSURE",
  GESTATIONAL_DIABETES = "GESTATIONAL_DIABETES",
  METABOLIC_CONDITIONS = "METABOLIC_CONDITIONS",
  PRETERM_LABOR_DELIVERY = "PRETERM_LABOR_DELIVERY",
  CESAREAN_BIRTH = "CESAREAN_BIRTH",
  PLACENTA_PREVIA_ACCRETA_ABRUPTION = "PLACENTA_PREVIA_ACCRETA_ABRUPTION",
  OTHER_CONDITION = "OTHER_CONDITION",
  OVER_35 = "OVER_35",
  NONE = "NONE"
}

export enum RespondedToSprintsScreener {
  YES = "YES"
}
